<template>
	<div @click="problemFeedbackHandle()"
		class="captureScreenBlo noPrint positionF lineHeight16 fontSize14 cursor cursorColor zIndex100 displayF2Center"
		:class="getClassStr">
		<img :src="initThemeImg(theme, 'icon_feekback@2x')" alt="" class="imgWH14 marginTop1" />
		<div>问题反馈</div>
	</div>
</template>

<script setup>
	import html2canvas from 'html2canvas-pro';
	import useUserStore from '@/store/modules/user.js'
	import {
		initThemeImg,
		setMessageQueue
	} from '@/utils/common'

	import {
		ref
	} from 'vue';

	const {
		proxy
	} = getCurrentInstance()

	const route = useRoute()

	// 主题色--默认亮色
	const theme = computed(() => {
		return useUserStore().theme
	})

	const captureOption = ref('fullpage')
	const selectedElement = ref('demo1')
	const screenshotData = ref(null)
	const isCapturing = ref(false)
	const screenshotSize = ref('0 x 0')
	const isDisabled = ref(false) // 重复点击
	const typeParams = ref(null) // 最后一级文本
	const nameParams = ref(null) // 倒数第二级文本，允许为空

	// 点击问题反馈
	function problemFeedbackHandle() {
		if (isDisabled.value) {
			setMessageQueue('warning', '请勿重复点击');
			return
		}

		isDisabled.value = true

		// 截图
		captureScreen()
	}

	// 根据路由参数 转换typeText
	function switchTypeText() {
		let str = ''
		const query = route.query
		const pageType = query.pageType || ''
		const path = route.path
		const id = query.id || ''
		const page = query.page || ''
		const type = query.type || ''
		const typeName = query.typeName || ''
		const number = query.number || ''
		const params = query.params ? JSON.parse(query.params) : null

		nameParams.value = ''

		if (pageType === 'members') {
			str = '添加成员'
		} else if (pageType === 'yw') {
			str = '添加运维'
		} else if (pageType === 'enterprisedetailsDataPage') {
			if (path === '/memberAccountEdit') {
				str = '成员信息'
			} else if (path === '/changeLogsDetails') {
				str = '日志详情'
			}
		} else if (pageType === 'enterpriseDataPage') {
			str = '主账号信息'
		} else if (pageType === 'accountMess') {
			str = '添加材料'
		} else if (pageType === 'noticeSetting') {
			if (path === '/pushMailPage') {
				if (id) {
					str = '站内模版编辑'
				} else {
					str = '站内模版新增'
				}
			} else if (path === '/pushBulletinPage') {
				if (id) {
					str = '公告模版编辑'
				} else {
					str = '公告模版新增'
				}
			} else if (path === '/pushNoticePage') {
				if (id) {
					str = '通告模版编辑'
				} else {
					str = '通告模版新增'
				}
			}
		} else if (pageType === 'myFeedback' || pageType === 'collectFeedbackPage' || pageType === 'xqFinancialFeedback') {
			str = '详情'
			if (pageType === 'collectFeedbackPage') {
				nameParams.value = '平台消息-收集反馈'
			} else if (pageType === 'xqFinancialFeedback') {
				nameParams.value = '问题反馈服务'
			} else {
				nameParams.value = '我的反馈'
			}
		} else {
			// 没有pageType时 任务大师相关页面
			if (typeName) {
				// 任务模板
				if (path === '/taskConfigurationAddAndEditTemplate') {
					if (id) {
						str = '编辑任务模板'
					} else {
						str = '添加任务模板'
					}
				} else {
					// 任务
					if (id) {
						str = '编辑'
					}
				}
			} else {
				if (path === '/taskAddAndEdit') {
					if (type === 'showAll') {
						nameParams.value = '查看全部'
					} else if (type === 'introduce') {
						nameParams.value = '详情'
					} else {
						nameParams.value = '任务中心'
					}

					// 任务
					if (id) {
						str = '编辑'
					} else {
						str = '添加任务'
					}
				} else if (path === '/changeLogsDetails' || path === '/memberAccountEdit') {
					str = '详情'
				} else if (path === '/pathInformationEdit') {
					if (id) {
						str = '编辑'
					} else {
						str = '添加路径'
					}
				} else if (path === '/pushMailPage') {
					str = '发布信息'
				} else if (path === '/pushBulletinPage') {
					if (id) {
						str = '编辑'
					} else {
						str = '发布公告'
					}
				} else if (path === '/pushNoticePage') {
					if (id) {
						str = '编辑'
					} else {
						str = '发布通告'
					}
				} else if (path === '/projectCreateAndIntroduceAndEdit') {
					if (id) {
						if (localStorage.getItem('isEditCommon')) {
							str = '编辑项目'
						} else {
							str = '项目介绍'
						}
					} else {
						str = '创建项目'
					}
				} else if (path === '/addEquipmentPage') {
					if (id) {
						str = '编辑设备'

						if (page === 'details') {
							nameParams.value = '详情'
						}
					} else {
						str = '新增设备'
					}
				} else if (path === '/generalArchiveCreateFile') {
					if (id) {
						if (localStorage.getItem('isEditCommon')) {
							str = '编辑'
						} else {
							str = '详情'
						}
					} else {
						str = '创建档案'
					}
				} else if (path === '/materialsEdit' || path === '/materialsDetails' || path ===
					'/memberArchiveNewMaterials') {
					const text = '材料'

					if (type === 'member') {
						nameParams.value = '档案类别-成员档案'
					} else if (type === 'general') {
						nameParams.value = '档案类别-综合档案'
					} else {
						nameParams.value = '档案类别-到期预警'
					}

					if (path === '/materialsEdit') {
						str = text + '编辑'
					} else if (path === '/materialsDetails') {
						str = text + '详情'
					} else if (path === '/memberArchiveNewMaterials') {
						if (number) {
							str = '追加'
						} else {
							str = '新建' + text
						}
					}
				} else if (path === '/productDescriptionGeneratorAddAndEdit') {
					nameParams.value = '产品说明生成器'

					if (id) {
						if (localStorage.getItem('isEditCommon')) {
							str = '编辑'
						} else {
							str = '查看详情'
						}
					} else {
						str = '新建说明书'
					}
				} else if (path === '/updateNotesGeneratorAddAndEditDocument') {
					nameParams.value = '更新文档生成器'

					if (id) {
						if (localStorage.getItem('isEditCommon')) {
							str = '编辑'
						} else {
							str = '文档介绍'
						}
					} else {
						str = '新建文档'
					}
				} else if (path === '/updateNotesGeneratorAddAndEditLogs') {
					nameParams.value = '更新文档生成器'

					if (id) {
						if (localStorage.getItem('isEditCommon')) {
							str = '日志编辑'
						} else {
							str = '查看详情'
						}
					} else {
						str = '添加日志'
					}
				}
			}
		}

		typeParams.value = str
		// alert(typeParams.value + nameParams.value)
	}

	// 根据路由参数 转换typeText
	function switchTypeProjectText() {
		let str = {
			type: '', // 倒数第一级
			name: '' // 倒数第二级
		}
		let query = route.query
		let path = route.path
		let params = query.params ? JSON.parse(query.params) : null

		// 模块
		if (params.pageType === 1) {
			str.name = '项目中心'

			if (params.id) {
				if (localStorage.getItem('isEditCommon')) {
					str.type = '编辑模块'
				} else {
					str.type = '模块详情'
				}
			} else {
				str.type = '创建模块'
			}
		} else {
			if (params.path === '/myToDo' || params.path === '/myCreate') {
				// /myToDo /myCreate
				str.name = '我的' + (params.path === '/myToDo' ? '待办' : '创建')

				if (params.id) {
					if (localStorage.getItem('isEditCommon')) {
						str.type = '编辑需求'
					} else {
						str.type = '需求详情'
					}
				}
			} else {
				if (params.isPar) {
					str.name = '模块详情'
				} else {
					str.name = '项目中心'
				}

				if (params.id) {
					if (localStorage.getItem('isEditCommon')) {
						str.type = '编辑需求'
					} else {
						str.type = '需求详情'
					}
				} else {
					str.type = '创建需求'
				}
			}
		}

		typeParams.value = str.type
		nameParams.value = str.name
		// alert(typeParams.value + '-' + nameParams.value)
	}

	// 截图
	function captureScreen() {
		isCapturing.value = true;

		// 使用setTimeout确保UI更新显示加载状态
		setTimeout(() => {
			let targetElement;

			if (captureOption.value === 'fullpage') {
				targetElement = document.body;
			} else {
				targetElement = document.getElementById(selectedElement.value);
			}
			
			console.log(targetElement, 'targetElement')
			
			html2canvas(targetElement, {
				scale: 2, // 提高截图质量
				useCORS: true,
				allowTaint: true,
				logging: false
			}).then(canvas => {
				console.log(canvas, 'canvascanvas')
				if (canvas) {
					screenshotData.value = canvas.toDataURL('image/png');
					screenshotSize.value = `${canvas.width} x ${canvas.height} 像素`;
					isCapturing.value = false;

					isDisabled.value = false

					if (route.path === '/moduleAndRequirementCreateAndEditAndDetails') {
						// 根据路由参数 转换typeText 项目追踪
						switchTypeProjectText()
					} else {
						// 根据路由参数 转换typeText
						switchTypeText()
					}

					const params = {
						route: route.path,
						type: typeParams.value,
						name: nameParams.value
					}

					console.log(screenshotData.value, screenshotSize.value, isCapturing.value,
						'html2canvas')
					// 给后端传base64格式图片
					proxy.$emit('captureScreen', screenshotData.value, params)
					// // 下载截图
					// downloadScreenshot()
				}
			}).catch(error => {
				isDisabled.value = false
				console.error('截图失败:', error);
				isCapturing.value = false;
				setMessageQueue('warning', '截图失败，请尝试清理缓存或重启浏览器');
			});
		}, 100);
	}

	// 下载截图
	function downloadScreenshot() {
		if (!screenshotData.value) return;

		const link = document.createElement('a');
		link.download = `screenshot-${new Date().getTime()}.png`;
		link.href = screenshotData.value;
		link.click();

		isDisabled.value = false
	}

	const getClassStr = ref(null)

	// 赋值点击状态 并监听后刷新当前列表数据
	watch(route, value => {
		setTimeout(() => {
			if (value.fullPath.includes('/dashboard')) {
				getClassStr.value = 'captureScreenBloSec'
			} else {
				getClassStr.value = null
			}
		})
		console.log(value, 'route valuevalue')
	}, {
		deep: true,
		immediate: true
	})
</script>

<style lang="scss" scoped>
	.captureScreenBlo {
		// top: 16px;
		top: 68px;
		right: 24px;
	}

	.captureScreenBloSec {
		font-size: 14px;
		top: 74px;
		position: fixed;
	}
</style>